<div class="container-fluid bg-white">
    <!--- header -->
    <header class="row align-items-center">
        <div class="col-xl-3 col-12" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
            <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28"/>
        </div>
        <div class="col-xl-9 col-12 px-xl-0">
            <app-onboarding-header></app-onboarding-header>
        </div>
    </header>
    <!--- body -->
    <section class="row" id="main-container">
        <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative">
            <div class="row">
                <div class="col-xl-6 col-md-6 col-12">
                    <h1>{{"PROFESSIONAL_EXPERIENCES" | translate}}</h1>
                    <small>{{'DESCRIBE_YOUR_EXPERIENCE' | translate}}</small>
                </div>
                <div class="col-xl-6 col-md-6 col-12 text-lg-right text-md-right text-left">
                    <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL'|translate" placement="top" class="cursor-pointer text-primary">{{'DONT_KNOW_HOW_TO_DO'|translate}}</span>
                </div>
            </div>
            <div class="row pb-2 mb-2 border-bottom pr-md-2" *ngFor="let exp of items_experiences; let i = index">
                <div class="form-group col-12 d-flex justify-content-end ">
                    <button (click)="addExperienceItem()" type="button" class="btn btn-success btn-circle btn-sm mr-1" rippleEffect >
                        <i class="fa fa-plus"></i>
                    </button>
                    <button (click)="removeExperienceItem(i)" type="button" class="btn btn-danger btn-circle btn-sm" rippleEffect>
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
                <div class="form-group col-md-6 col-xl-2 col-12">
                    <label [for]="'experience_agency_'+i">{{'AGENCY_NAME' | translate}}<sup class="text-danger">*</sup></label>
                    <input type="text" [id]="'experience_agency_'+i" class="form-control" placeholder="{{'AGENCY_NAME' | translate}}" [(ngModel)]="exp.agency"/>
                </div>
                <div class="col-md-6 col-xl-3 col-12 form-group">
                    <label [for]="'experience_customer_'+i">{{'CUSTOMER' | translate}}</label>
                    <input type="text" [id]="'experience_customer_'+i" class="form-control" [(ngModel)]="exp.customer"/>
                </div>
                <div class="form-group col-xl-3 col-12">
                    <label [for]="'experience_figure_'+i">{{'FIGURE' | translate}}<sup class="text-danger">*</sup></label>
                    <ng-select [id]="'experience_figure_'+i" [(ngModel)]="exp.figure" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                        <ng-option *ngFor="let field of _userFigureService.list" [value]="field.id">{{field.name}}</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col-md-6 col-xl-2 col-12">
                    <label [for]="'experience_from_'+i">{{'FROM_PERIOD' | translate}}<sup class="text-danger">*</sup></label>
                    <input [(ngModel)]="exp.from" type="date" [max]="today" [id]="'experience_from_'+i" class="form-control"/>
                </div>
                <div class="form-group col-md-6 col-xl-2 col-12">
                    <label>{{'TO_PERIOD'| translate}}<sup class="text-danger" *ngIf="!exp.isCurrentExperience">*</sup></label>
                    <input [(ngModel)]="exp.to" type="date" [max]="today" [id]="'experience_to_'+i" class="form-control" [min]="exp.from" [disabled]="!exp.from || exp.isCurrentExperience "/>
                </div>
                <div class="form-group col-xl-8 col-12">
                    <label [for]="'experience_description_' + i">{{"INSERT.DESCRIBE_EXPERIENCE" | translate}}
                        <sup class="text-danger">*</sup></label>
                    <textarea [(ngModel)]="exp.description" [id]="'experience_description'+ i" placeholder="{{'INSERT.WRITE_EXPERIENCE' | translate}}" class="form-control p-0 m-0"></textarea>
                </div>
                <div class="col-xl-4 col-12">
                    <div class="form-group">
                        <div class="d-flex align-items-xl-center justify-content-xl-between">
                            <label class="mb-0">{{"IS_CURRENT_EXPERIENCE" | translate}}</label>
                            <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                                <input [id]="'is_current_experience'+ i" type="checkbox" class="custom-control-input" [(ngModel)]="exp.isCurrentExperience"
                                    (change)="exp.to = null"/>
                                <label class="custom-control-label" [for]="'is_current_experience' + i"></label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label [for]="'experience_domain_'+i">{{'DOMAIN' | translate}}<sup class="text-danger">*</sup></label>
                        <ng-select [id]="'experience_domain_' + i" bindLabel="name" bindValue="id" [items]="_workDomainService.list"
                                   [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [(ngModel)]="exp.domain">
                        </ng-select>
                    </div>
                    <div class="form-group">
                        <label [for]="'experience_tecnology_' + i">{{'TECNOLOGIES' | translate}}<sup class="text-danger">*</sup></label>
                        <ng-select [multiple]="true" [id]="'experience_tecnology_'+ i" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                                   bindLabel="name" bindValue="id" [items]="_skillService.list_enabled" [(ngModel)]="exp.tecnologyApproved">
                        </ng-select>
                        <div class="form-group col-12 pl-0" [ngClass.sm]="'mt-1'">
                            <p class="sugges-new-item" (click)="modalOpen(modalAddSkill, i)">{{"MODAL.NOT_SKILL_CANDIDATE" | translate}}</p>
                        </div>
                        <div class="form-group col-12 pl-0 mb-0" *ngIf="skillToPropose[i] && skillToPropose[i].skill.length > 0">
                            {{'SKILLS_TO_APPROVE' | translate}}: <span *ngFor="let item of skillToPropose[i].skill" class="badge badge-secondary ml-1 mb-025">{{item}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pr-md-2">
                <div class="col-md-7 col-12" *ngIf="skillWaitingToApprove && skillWaitingToApprove.length > 0">
                    {{'SKILLS_TO_APPROVE' | translate}}: <span *ngFor="let item of skillWaitingToApprove" class="badge badge-secondary ml-1 mb-025">{{item.name}}</span>
                </div>
                <div class="col-md-{{skillWaitingToApprove && skillWaitingToApprove.length > 0 ? '5' : '12'}} col-12 d-flex justify-content-end mb-4">
                    <button (click)="save()" type="submit" class="btn btn-primary">{{"NEXT" | translate}}</button>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Modal New Skill -->
<ng-template #modalAddSkill let-modal>
    <form (ngSubmit)="addModalObjectSkill();modal.close()">
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"MODAL.NOT_SKILL_CANDIDATE" | translate}}</h3>
            <p>{{"MODAL.INSERT_HERE" | translate}}</p>
            <label [for]="'new_skill'">{{'SKILLS' | translate}}<sup class="text-danger">*</sup></label>
            <input name="new_skill" [(ngModel)]="new_skill" type="text" [id]="'new_skill'" class="form-control"/>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="submit" class="btn btn-primary w-150" rippleEffect>{{"SEND" | translate}}</button>
        </div>
    </form>
</ng-template>
<!-- / Modal New Skill -->